module.exports = __webpack_public_path__ + "media/images/article/2022_03_b-98c8316963188e3c3e91ad46387b0b17.png";